import styled from "styled-components";
import { Select as SelectOrigial, Radio as RadioOriginal, DatePicker as DatePickerOriginal } from 'antd';
import { PoolTable, NavigationBtnContainer } from '../../styles';

export const Input = styled.input`
border: solid 1px ${props => props.theme.border.filledTabsInactive};
width: 100px;
height: 3.125rem;
padding: 0px 10px;
@media only screen and (max-width: 991px) {
  width: 130px;
}
@media only screen and (min-width: 320px) and (max-width: 374px) {
  width: 100%;
}
${props => {
    return (
      (props.disabled === true) &&
      `background-color:${props.theme.backgroundColor.tableInputDisabled}; border: none;`
    );
  }}
`;

export const ExchangeFromTable = styled(PoolTable)`
  .ant-table-row{
    border-bottom: none !important; 
  }
  .ant-table-row:nth-child(2n + 1) {
    background-color: ${props =>
    props.theme.backgroundColor.tableAltRowDark}!important;
  }
  .ant-input-number {
    width: 100% !important;
    .ant-input-number-handler-wrap {
      display: none;
    }
  }
  .ant-table-footer {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-bottom: solid 1px #d4d4d4;
    height: 80px;
    padding: 20px 0;
    @media only screen and (max-width: 767px) {
      height: auto;
      border-top: solid 1px #d4d4d4;
      border-radius: 0;
      padding: 10px 0;
    }
  }
`;

export const RadioInputGroupLabel = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: 1.43;
  color: ${props => props.theme.fontColors.textColor};
`;

export const FromTableFooter = styled.div`  
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.heading};
  letter-spacing: ${props => props.theme.letterSpacing.point6};
  align-items: center;  
`;

export const FromTableFooterCol = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  width: calc(100% - 240px);  
  @media only screen and (max-width: 767px) {
    width: 100%;
    display: block;
    padding: 0;
  }
`

export const Form = styled.form`
  &&& {
    margin-top: ${props => props.theme.spacing.margins.YBetween};
  }
  .ant-form-item-label > label::after {
    margin: 0px;
  }
`;

export const FormContainer = styled.div`
  margin: 30px 0 10px;  
  @media only screen and (max-width: 767px) {
    margin: 20px 0 0;
  }
  .ant-form-item-label > label::after {
    margin: 0px;
  }
  .ant-col{
    margin-bottom: 40px;    
    @media only screen and (max-width: 991px) {            
      .ant-calendar-picker{
        width: 100%;
        max-width: 316px
      }
    }
  }
`;


export const ValidationMessage = styled.div.attrs(()=>({
  className: "error-fields"
  }))`  
  display: none;
  position: absolute;
  font-size: ${props => props.theme.fontSize.primary};  
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.error};
  ${({ visible }) => visible && `
    display: block;
  `}
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const Select = styled(SelectOrigial)`
  width: 300px !important;
  .ant-select-selection__rendered {    
    height: 40px;
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
  .ant-select-selection.ant-select-selection--single {
    width: 300px !important;
  }
  .ant-select-arrow {
    background-color: ${props => props.theme.backgroundColor.pill};
    border-left: 1px solid ${props => props.theme.border.pill}
  }
  .ant-select-selection__placeholder {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    height: auto;    
    letter-spacing: ${props => props.theme.letterSpacing.zero};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    color: ${props => props.theme.colors.border}!important;
    @media only screen and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
  .ant-select-selection-selected-value {
    font-size: ${props => props.theme.fontSize.primary};
    letter-spacing: ${props => props.theme.letterSpacing.zero};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.3;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.fontColors.textColor};
    @media only screen and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
  @media (max-width: 991px) {
    width: 100% !important;
    max-width: 316px;
    .ant-select-selection.ant-select-selection--single {
      width: 100% !important;
    }
  }
`;

export const Option = styled.option``;

export const Label = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  font-weight: normal;
  margin: 0px;
  padding-bottom: 10px;
  @media only screen and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const Radio = styled(RadioOriginal)`
  .ant-radio-inner::after {
    background-color: #006778;
    width: 10px !important;
    height: 10px !important;
    max-height: 10px !important;
    max-width: 10px !important;
    border-radius: 50%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    display: block;
  }
  .ant-radio-checked .ant-radio-inner {
    border-color: #006778;
  }

  .ant-radio:hover .ant-radio-checked .ant-radio-inner {
    border-color: #006778;
  }
`;


export const FromNavigationBtnContainer = styled(NavigationBtnContainer)``;

export const Footer = styled.div`
  width: 63%;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.heading};
  letter-spacing: ${props => props.theme.letterSpacing.point6};
  align-items: center;
  @media only screen and (min-device-width: 1093px) and (max-device-width: 1177px) {
    width: 59%;
  }
  @media only screen and (min-device-width: 1178px) and (max-device-width: 1240px) {
    width: 61%;
  }
`;

export const FooterText = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: #505050;
  font-weight: normal;
  margin: 0;
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const TableSpan = styled.div`  
  @media only screen and (max-width: 991px) {
    margin: 5px 0 0;
  }  
`;

export const TotalSpan = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.theme.fontColors.headingColor};
  background-color: #fff;
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 20px;
 // font-weight: bold;
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const DatePicker = styled(DatePickerOriginal)`
  .ant-calendar-picker-input {
    padding-left: 19px;
    margin-top: 0px !important;
    cursor: pointer;
    border-radius: 0px;
    font-size: ${props => props.theme.fontSize.primary} !important;
    letter-spacing: ${props => props.theme.letterSpacing.zero};
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.fontColors.textColor};
    width: 300px;
    &::placeholder {
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      color: ${props => props.theme.colors.border}!important;
    }
    ${({ disableIcon }) =>
    disableIcon &&
    `
    cursor: not-allowed;
  `}
    .ant-calendar-picker-icon {
      margin-right: 20px !important;
    }
    @media only screen and (max-width: 991px) {
      width: 100%;
    }
    @media only screen and (max-width: 767px) {
      font-size: 14px !important;
    }
  }
`;

export const NumberInput = styled.input`
  width: 300px !important;
  height: 40px;
  border-radius: 0px;
  padding-left: 19px;
  font-size: ${props => props.theme.fontSize.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  border: solid 1px ${props => props.theme.border.pill};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  &:focus {
    border: 1px solid ${props => props.theme.colors.tabHead} !important;
    outline-color: ${props => props.theme.colors.tabHead} !important;
    outline-width: 1px !important;
  }
  &::placeholder {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.colors.border}!important;;
  }
  &::-webkit-input-placeholder {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.colors.border}!important;;

}
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
    display: none;
  }
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
    display: none;
  }
  .ant-input-number-input {
    height: 40px;
  }
  &[disabled]{
    cursor: not-allowed;
  }
  @media only screen and (max-width: 991px) {
    width: 100% !important;
  }
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;
export const RadioButtonText = styled.div`
marginBottom: 0px;
@media only screen and (max-width: 767px) {
  color:${props => props.theme.colors.tabHead};
letter-spacing:${props => props.theme.letterSpacing.zero};
}

`;